import { render, staticRenderFns } from "./ServiceTutorEditExpertiseDetails.vue?vue&type=template&id=3bf2a1a9&scoped=true&"
import script from "./ServiceTutorEditExpertiseDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceTutorEditExpertiseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTutorEditExpertiseDetails.vue?vue&type=style&index=0&id=3bf2a1a9&prod&scoped=true&lang=css&"
import style1 from "./ServiceTutorEditExpertiseDetails.vue?vue&type=style&index=1&id=3bf2a1a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2a1a9",
  null
  
)

export default component.exports